import React from 'react'
import { Alert } from 'hhsoig-design-system-core'

export const Process = () => {
  return (
    <div>
      <h1 className="ds-u-font-size--h2">How the complaint process works</h1>
      <p>
        Below is an overview of the steps that HHS-OIG takes to process
        complaints involving retaliation for whistleblower actions.
      </p>
      <h2 className="ds-u-font-size--h3">Complaint submitted</h2>
      <p>
        You can submit a complaint through this website or by calling us. Make
        sure you provide us with the information we’re requesting and that
        you’re aware of all the options available to you.
      </p>
      <Alert heading="Information">
        Failure to provide the required information is the top reason we find
        complaints ineligible.
      </Alert>
      <h2 className="ds-u-font-size--h3">Review for eligibility</h2>
      <p>
        Once its submitted, our Hotline team will review your complaint to
        determine whether it is eligible. If it is found eligible, it will be
        assigned to an investigator for further review.
      </p>
      <p>
        We receive thousands of submissions annually through our Hotline, and we
        are unable to respond to complaints deemed ineligible.
      </p>
      <h2 className="ds-u-font-size--h3">Investigation occurs</h2>
      <p>
        An investigator will review a submitted complaint to substantiate its
        details. During this review, an investigator may reach out to the person
        who submitted the complaint to discuss the case or gather more
        information. The investigator may also contact the persons involved in
        the complaint.
      </p>
      <h2 className="ds-u-font-size--h3">Review complete</h2>
      <p>
        Once the review is complete, the investigator will make a recommendation
        for action – or no action – based on the results of that investigation.
      </p>
    </div>
  )
}
